export default {
  computed: {
    $typeAheadAboutsSpiritual() {
      return [
        { value: null, text: "optional" },
        { value: "Christianity", text: "Christianity" },
        { value: "Islam", text: "Islam" },
        { value: "Irreligious", text: "Irreligious affiliation" },
        { value: "Hinduism", text: "Hinduism" },
        { value: "Buddhism", text: "Buddhism" },
        { value: "Judaism", text: "Judaism" },
        { value: "Catholicism", text: "Catholicism" }
      ];
    }
  }
};
